import React, { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from './LanguageContext';
import logo from './images/logo on web.png';



import { adminLogin } from './api';

export default function AdminLogin() {
  const navigate = useNavigate();
  const { language, setLanguage, t } = useLanguage();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  // Load Google Fonts dynamically
  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }, []);

  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      .login-input::placeholder {
        color: #000000 !important;
        opacity: 1;
      }
    `;
    document.head.appendChild(style);
  }, []);


  const handleSubmit = async () => {
    console.log('Login attempt:', { email, password });

    if (!email || !password) {
      toast.error("Please enter both email and password.");
      return;
    }

    try {
      const response = await adminLogin({ email, password });

      // Save tokens and user info
      localStorage.setItem('access_token', response.access_token);
      localStorage.setItem('refresh_token', response.refresh_token);
      // We assume response.user is an object, so we stringify it
      localStorage.setItem('user', JSON.stringify(response.user));

      console.log("Login successful, redirecting to Home...");
      toast.success("Login successful!");
      navigate('/Home');
    } catch (error) {
      console.error("Login failed:", error);
      toast.error("Login failed: " + (error.message || "Unknown error"));
    }
  };

  return (
    <div
      className="min-h-screen w-full flex flex-col items-center justify-start pt-0 font-poppins "
      style={{
        background: `
  radial-gradient(circle at left bottom, #2A3A40 0%, #4A5C63 15%, rgba(0,0,0,0) 45%),
  linear-gradient(135deg, #FFFFFF 0%, #B8C3CA 35%, #7C8E97 70%, #2E3F47 100%)
`,
      }}
    >
      {/* Small language selector (fixed top-right) */}
      <div className="fixed top-3 right-3 z-50">
        <div className="w-auto bg-gradient-to-b from-white to-[#F0F2F5] rounded-full shadow-[0_8px_16px_-4px_rgba(0,0,0,0.1)] hover:shadow-[0_10px_20px_-4px_rgba(0,0,0,0.15)] transition-all">
          <select
            aria-label={t ? t('languageLabel') : 'Language'}
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
            className="text-sm bg-transparent px-4 py-2 rounded-full outline-none"
          >
            <option value="it">Italian</option>
            <option value="en">English</option>
          </select>
        </div>
      </div>
      {/* Logo Image */}
      <img
        src={logo}
        alt="Logo"
        className="w-full max-w-[320px] h-auto object-cover mt-0 mb-4"
      />

      <h1
        className="text-2xl font-semibold text-black mt-0 mb-4 tracking-normal text-center px-4"
        style={{ fontFamily: 'Poppins, sans-serif' }}
      >
        {t ? t('adminTitle') : 'Accesso amministratore'}
      </h1>

      {/* Login Form Container */}
      <div
        className="w-full max-w-[340px] rounded-[43px] px-7 py-4 h-auto mb-4 flex justify-center items-center bg-[#36434dff] shadow-[0_15px_40px_rgba(0,0,0,0.4)]"
      >
        <div className="flex flex-col gap-3 w-full">
          {/* Email Input */}
          <div>
            <input
              type="email"
              placeholder={t ? t('emailPlaceholder') : 'E-mail'}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="login-input w-full px-6 py-2 rounded-full border-none outline-none bg-white text-black text-[14px] font-poppins box-border"
            />
          </div>

          {/* Password Input */}
          <div>
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="login-input w-full px-6 py-2 rounded-full border-none outline-none bg-white text-black text-[14px] font-poppins box-border"
            />
          </div>

          {/* Forgot Password Link */}
          <div className="text-right -mt-2.5 leading-3">
            <button className="bg-none border-none text-[#CDD5DB] text-xs font-poppins cursor-pointer underline">
              {/* {t ? t('forgotPassword') : 'Hai dimenticato la password?'} */}
            </button>
          </div>
        </div>
      </div>

      {/* Login Button */}
      <button
        onClick={handleSubmit}
        className="w-full max-w-[325px] py-3.5 rounded-full border-none font-semibold text-white bg-gradient-to-br from-[#02131bff] to-[#364f58ff] shadow-[0_10px_30px_rgba(0,0,0,0.5)] text-base tracking-wide cursor-pointer transition-opacity font-poppins text-center hover:opacity-90"
      >
        {t ? t('loginButton') : 'Accedi'}
      </button>
    </div>
  );
}
